import { ApolloError } from '@apollo/client';

import { getGraphQLErrorCodes } from './graphqlError';
import { ErrorCode } from '../gen/graphql';

// APIエラー時に表示するメッセージ
export const getApplyPromotionCodeErrorMessage = (error: ApolloError): string => {
  const errorCodes = getGraphQLErrorCodes(error);
  if (errorCodes.includes(ErrorCode.StripePromotionCodeAlreadyUsedErr)) {
    return 'ご利用いただいたクーポンは初回契約のみ有効なクーポンです。';
  }
  if (errorCodes.includes(ErrorCode.PromotionCodeIsUsed)) {
    return 'ご利用いただいたクーポンは使用済みです。';
  }
  return 'このクーポンコードは利用できません。大文字と小文字は区別されるのでご注意ください。';
};
